<template>
  <v-dialog v-model="showDialog" max-width="550px" max-height="600px">
    <v-card >
      <v-card-title class="primary white--text text-h5 font-weight-bold flex align-center justify-start">
        <p>Report this Comment</p>

      </v-card-title>
      <v-card-text class="ma-0">
        <v-textarea
          v-model="reportMessage"
          placeholder="Why would you like to report this commnent?"
          outlined
          class="mx-2 mt-5 mb-0"
          style="height: '100%'"
        />
      </v-card-text>
      <v-divider class="gray" />
      <v-card-actions class="ma-0 mt-0">
        <v-container>
          <v-row no-gutters>
            <v-spacer />
            <v-col cols="auto" class="mr-3">
              <v-btn
                color="error"
                dark
                depressed
                @click="submitComment"
                :disabled="!commentId || reportMessage.length < 3"
                :loading="isLoading"
              >Report</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                color="primary"
                dark
                outlined
                @click="showDialog = !showDialog"
                :disabled="isLoading"
              >Cancel</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReportComment',
  data: () => ({
    showDialog: false,
    commentId: '',
    reportMessage: '',
    isLoading: false,
    showToast: false,
    toast: {
      state: '',
      message: '',
      duration: 5500
    }
  }),
  methods: {
    open(commentId) {
      if (commentId) {
        this.commentId = commentId;
        this.showDialog = true;
      }
    },
    async submitComment() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('comments/REPORT_COMMENT', {
          id: this.commentId,
          reportMessage: this.reportMessage
        });
        this.commentId = '';
        this.reportMessage = ''
        this.showDialog = false;
        this.$swal.fire({
          icon: 'success',
          html: `
            <p>The comment has been reported!</p>
            <br />
            <p>This report is forwarded to the admins.</p>
          `
        })
      } catch(err) {
        console.log('ERR WHILE REPORTING COMMENTS: ', err);
        this.$swal.fire({
          icon: 'error',
          text: 'Something went wrong while submitting report, please try again later.'
        })
      }
      this.isLoading = false;
    }
  }
}
</script>
